import BaseModel from '../BaseModel';
import Address from '../Address/Address';
import Logo from './Logo';
import OfficePhoto from './OfficePhoto';
import Vacancy from '../Vacancy/Vacancy';
import Settings from './Settings';
import NotificationTemplate from './NotificationTemplate/NotificationTemplate';
import Country from '../Country/Country';

export default class Company extends BaseModel {
  static entity = 'companies';

  static primaryKey = 'id';

  static fields() {
    return {
      id: this.attr(null),
      name: this.string(null).nullable(),
      site: this.string(null).nullable(),
      about: this.string(null).nullable(),
      logo: this.hasOne(Logo, 'companyId'),
      officePhotos: this.hasMany(OfficePhoto, 'companyId'),
      addresses: this.hasMany(Address, 'companyId'),
      profileCompleteness: this.attr(null),
      settings: this.hasOne(Settings, 'companyId'),
      notificationTemplates: this.hasMany(NotificationTemplate, 'companyId'),
      candidateStatuses: this.attr(null),
      countryId: this.attr(null),
      country: this.belongsTo(Country, 'countryId'),
      permissions: this.attr({
        vacancyStore: false,
      }),
      companyPartnerCode: this.attr(null),
      companyTemplateSettings: this.attr(null),
      candidateAdditionalFields: this.attr(null),
      templateHasChanges: this.attr(null),
      referralDiscountPercent: this.attr(null),
      referralPayoutPercent: this.attr(null),
    };
  }

  get vacanciesCount() {
    return Vacancy.query()
      .where('companyId', this.id)
      .count();
  }

  static apiConfig = {
    actions: {
      fetch() {
        return this.get('companies/authenticated');
      },
      store(payload) {
        return this.post('companies', payload, { save: false });
      },
      update(id, payload) {
        return this.put(`companies/${id}`, payload);
      },
      async fetchProfileCompleteness(id) {
        const result = await this.get(`companies/${id}/status`, { save: false });
        this.model.update({
          id,
          profileCompleteness: result.response.data.data,
        });
        return result;
      },
      async fetchIntegrationTokenStatus(code) {
        return this.get(`companies/integration/toket_status/${code}`, { save: false });
      },
      async updateTemplateSettings(companyId, payload) {
        return this.put(`companies/${companyId}/templates`, payload);
      },
      async applyTemplate(companyId, payload) {
        return this.post(`companies/${companyId}/templates/apply`, payload);
      },
      async setRedacting(templateId) {
        return this.post(`companies/templates/redacting/${templateId}`, {}, { save: false });
      },
      async disableAllTemplates() {
        return this.post('companies/templates/disable_all_templates');
      },
      async addCandidatesAdditionalFields(payload) {
        return this.post('companies/candidates-additional-fields', payload);
      },
      async getCandidateAiProcessorSettings() {
        return this.get('companies/candidate-ai-processor-settings/settings', { save: false });
      },
      async updateCandidateAiProcessorSettings(payload) {
        return this.post('companies/candidate-ai-processor-settings/settings', payload, { save: false });
      },
      async getCandidateAiProcessorSettingsByVacancy(vacancyId) {
        return this.get(`companies/candidate-ai-processor-settings/vacancy/${vacancyId}/settings`, { save: false });
      },
      async updateCandidateAiProcessorSettingsByVacancy(vacancyId, payload) {
        return this.post(`companies/candidate-ai-processor-settings/vacancy/${vacancyId}/settings`, payload, { save: false });
      },
    },
  };
}
